const FOCUSBAAR = 'a[href], button:not([disabled]), input, select, textarea';

function initHeader() {
  const header = document.querySelector('[data-vt-header]');
  if (!header || header.dataset.vtInit === '1') return;
  header.dataset.vtInit = '1';

  const paneelSjablonen = header.querySelectorAll('template[data-vt-paneel]');
  if (paneelSjablonen.length) {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const plaats = (tpl) => {
      if (tpl.isConnected) tpl.replaceWith(tpl.content.cloneNode(true));
    };
    const allemaal = () => paneelSjablonen.forEach(plaats);
    paneelSjablonen.forEach((tpl) => {
      const item = tpl.closest('.vt-nav__item');
      if (!item) return;
      const vroeg = () => plaats(tpl);
      item.addEventListener('pointerenter', vroeg, { once: true });
      item.addEventListener('focusin', vroeg, { once: true });
    });
    const opDesktop = () => {
      if (!desktop.matches) return;
      if ('requestIdleCallback' in window) requestIdleCallback(allemaal, { timeout: 3000 });
      else setTimeout(allemaal, 1500);
    };
    if (window.Shopify && window.Shopify.designMode) allemaal();
    else opDesktop();
    desktop.addEventListener('change', opDesktop);
  }

  const zoekKnop = header.querySelector('[data-vt-searchtoggle]');
  const zoekPaneel = document.getElementById('vt-search-mobile');

  if (zoekKnop && zoekPaneel) {
    zoekKnop.addEventListener('click', () => {
      const open = zoekPaneel.hasAttribute('hidden');
      zoekPaneel.toggleAttribute('hidden', !open);
      zoekKnop.setAttribute('aria-expanded', String(open));
      if (open) zoekPaneel.querySelector('input')?.focus();
    });
  }

  const lade = document.querySelector('[data-vt-drawer]');
  const burger = header.querySelector('[data-vt-burger]');
  if (!lade || !burger) return;

  const paneel = lade.querySelector('.vt-drawer__panel');
  const titel = lade.querySelector('[data-vt-drawer-title]');
  const basisTitel = titel ? titel.textContent : '';
  const niveaus = lade.querySelectorAll('[data-vt-level]');
  let laatsteFocus = null;

  function toonNiveau(sleutel) {
    niveaus.forEach((el) => {
      el.toggleAttribute('hidden', el.dataset.vtLevel !== sleutel);
    });
    const actief = lade.querySelector(`[data-vt-level="${sleutel}"]`);
    if (!actief) return;
    if (titel) {
      titel.textContent =
        sleutel === 'root' ? basisTitel : actief.dataset.vtParentTitle || basisTitel;
    }
    actief.scrollTop = 0;
    actief.querySelector(FOCUSBAAR)?.focus();
  }

  function zetOpen(open) {
    lade.toggleAttribute('hidden', !open);
    if (open) void lade.offsetWidth;
    lade.toggleAttribute('data-open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';

    if (open) {
      laatsteFocus = document.activeElement;
      toonNiveau('root');
      lade.querySelector('[data-vt-close]')?.focus();
    } else {
      toonNiveau('root');
      laatsteFocus?.focus();
    }
  }

  burger.addEventListener('click', () => zetOpen(lade.hasAttribute('hidden')));

  lade.querySelectorAll('[data-vt-close]').forEach((el) => {
    el.addEventListener('click', () => zetOpen(false));
  });

  lade.addEventListener('click', (e) => {
    const open = e.target.closest('[data-vt-open-sub]');
    if (open) {
      open.setAttribute('aria-expanded', 'true');
      toonNiveau(open.dataset.vtOpenSub);
      return;
    }
    if (e.target.closest('[data-vt-back]')) toonNiveau('root');
  });

  document.addEventListener('keydown', (e) => {
    if (lade.hasAttribute('hidden')) return;

    if (e.key === 'Escape') {
      const huidig = lade.querySelector('[data-vt-level]:not([hidden])');
      if (huidig && huidig.dataset.vtLevel !== 'root') toonNiveau('root');
      else zetOpen(false);
      return;
    }

    if (e.key !== 'Tab') return;
    const items = [...paneel.querySelectorAll(FOCUSBAAR)].filter(
      (el) => el.offsetParent !== null
    );
    if (!items.length) return;
    const eerste = items[0];
    const laatste = items[items.length - 1];
    if (e.shiftKey && document.activeElement === eerste) {
      e.preventDefault();
      laatste.focus();
    } else if (!e.shiftKey && document.activeElement === laatste) {
      e.preventDefault();
      eerste.focus();
    }
  });

  document.addEventListener('shopify:section:load', () => zetOpen(false));
  document.addEventListener('shopify:section:select', () => zetOpen(false));
}

function meetHoogte() {
  const sectie = document.querySelector('.vt-header-section');
  if (!sectie || !('ResizeObserver' in window)) return;
  const zet = () => {
    document.body.style.setProperty('--vt-sticky-top', `${Math.round(sectie.getBoundingClientRect().height)}px`);
  };
  new ResizeObserver(zet).observe(sectie);
  zet();
}

initHeader();
meetHoogte();
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector?.('[data-vt-header]')) {
    e.target.querySelector('[data-vt-header]').dataset.vtInit = '';
    initHeader();
  }
});
